import { Box, Skeleton, Typography } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

export const LoadingSkeleton = ({ text }) => {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '60%' },
        margin: '0 auto'
      }}
    >
      <Typography variant='h6' sx={{ mb: 2 }}>
        {text}
      </Typography>
      <Skeleton variant='text' width='60%' />
      <Skeleton variant='text' width='40%' />
      <Skeleton variant='circular' width={60} height={60} />
      <Skeleton variant='rectangular' width='100%' height={118} />
    </Box>
  )
}

LoadingSkeleton.propTypes = {
  text: PropTypes.string.isRequired
}
